import { Component, Input } from '@angular/core';

/**
 * Editorial card primitive — body slot with optional head + foot slots.
 * Mirrors the mockup `.card` pattern: white bg, hairline border, 10px radius.
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-card',
    template: `
<div class="cd">
    <div class="cd__head" *ngIf="hasHead">
        <ng-content select="[head]"></ng-content>
    </div>
    <div class="cd__body" [class.cd__body--p]="!noPadding">
        <ng-content></ng-content>
    </div>
    <div class="cd__foot" *ngIf="hasFoot">
        <ng-content select="[foot]"></ng-content>
    </div>
</div>
    `,
    styles: [`
        :host { display: block; }
        .cd { background: var(--mj-bg-surface, #fff); border: 1px solid var(--mj-border-default, #e0e0e0); border-radius: 10px; }
        .cd__head { display: flex; align-items: center; justify-content: space-between; padding: 0 20px; height: 48px; border-bottom: 1px solid var(--mj-border-default, #e0e0e0); }
        .cd__body--p { padding: 20px; }
        .cd__foot { padding: 12px 20px; border-top: 1px solid var(--mj-border-default, #e0e0e0); display: flex; align-items: center; justify-content: space-between; font-size: 12px; color: var(--mj-text-secondary, #71717a); }
    `]
})
export class CardComponent {
    @Input() hasHead = false;
    @Input() hasFoot = false;
    @Input() noPadding = false;
}
